"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerItemsInArray = void 0;
var NotFoundError_1 = require("./errors/NotFoundError");
var Registration_1 = require("./Registration");
/**
 * Push item into array and return object representing this pushment that can be destroyed
 * Warning: this utility makes mutations on base record object
 */
function registerItemsInArray(_a) {
    var base = _a.base, add = _a.add, compare = _a.compare, collisionStrategy = _a.collisionStrategy;
    compare = compare || (function (a, b) { return a === b; });
    collisionStrategy = collisionStrategy || 'ERROR';
    for (var _i = 0, add_1 = add; _i < add_1.length; _i++) {
        var item = add_1[_i];
        base.push(item);
    }
    return new Registration_1.Registration(function () {
        var _loop_1 = function (item) {
            var index = base.findIndex(function (item2) { return compare(item, item2); });
            if (index === -1) {
                var error = new NotFoundError_1.NotFoundError("Item was not found in array. Array was probbably mutated with some other function.");
                if (collisionStrategy === 'ERROR') {
                    /*
                    // TODO: DRY
                    console.info(/* TODO: Unify error infos* / 'ERROR_INFO', {
                        error,
                        base /* TODO: Converting MobX * /,
                        item,
                    });
                    */
                    throw error;
                }
                else if (collisionStrategy === 'WARN') {
                    /*
                    // TODO: DRY
                    console.info(/* TODO: Unify error infos* / 'ERROR_INFO', {
                        error,
                        base /* TODO: Converting MobX * /,,
                        item,
                    });
                    */
                    console.warn(error);
                }
            }
            base.splice(index, 1);
        };
        for (var _i = 0, add_2 = add; _i < add_2.length; _i++) {
            var item = add_2[_i];
            _loop_1(item);
        }
    });
}
exports.registerItemsInArray = registerItemsInArray;
//# sourceMappingURL=registerItemsInArray.js.map